import Image from 'next/image';
import Icon from './helloeroRedRotate.svg?url';
import type { SvgImageProps } from '../_type';

export const HelloeroRedRotateImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={Icon} alt={alt} {...props} />;
